import { Command } from "@ckeditor/ckeditor5-core";

import interactionTypes from "./interactionTypes.json";

export default class CreateInteractionCommand extends Command {
  execute({ label }) {
    const type = interactionTypes.find((o) => o.label === label).type;
    this.editor.fire("cde:createInteraction", { type });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;
    const blockAllowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "blockInteractionElement",
    );
    const inlineAllowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "inlineInteractionElement",
    );

    this.isEnabled = blockAllowedIn !== null && inlineAllowedIn !== null;
  }
}
